import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of, switchMap, take } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { Rating, RatingsService } from '../services/ratings.service';
import { getFormatsFromFormatParam } from '../tools/convert/get-formats-from-format-param';

export const convertStoryblokCustomRatingsResolver: ResolveFn<Observable<Rating[]>> = route => {
  // const storyblokHelperService = inject(StoryblokHelperService);
  const ratingsService = inject(RatingsService);
  const storyblokService = inject(PICFLOW_STORYBLOK);

  const { to: toFormatSlug } = getFormatsFromFormatParam(route.params.format);
  const path = toFormatSlug ? 'convert/conversion-template' : 'convert/format-template';

  return storyblokService.getUniqueComponentsList(route, path).pipe(
    switchMap(components => {
      if (!components.has('CustomRatingDisplay')) return of(undefined);
      return ratingsService.getCustomRatings().pipe(take(1));
    })
  );
};
